import Vue from 'vue'
import VueRouter from 'vue-router'
import special from '../views/special/special.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'special',
    meta:{
      title: "工会专区"
    },
    component: special
  },
  {
    path: '/detail1',
    name: 'detail1',
    meta:{
      title: "在职职工医疗互助保障计划"
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/special/detail1.vue')
  },
  {
    path: '/detail2',
    name: 'detail2',
    meta:{
      title: "非工伤意外伤害及家财损失保障"
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/special/detail2.vue')
  },
  {
    path: '/detail3',
    name: 'detail3',
    meta:{
      title: "在职职工住院医疗互助保障"
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/special/detail3.vue')
  },
  {
    path: '/detail4',
    name: 'detail4',
    meta:{
      title: "在职职工住院津贴互助保障"
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/special/detail4.vue')
  },
  {
    path: '/accident',
    name: 'accident',
    meta:{
      title: "意外伤害给付"
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/special/accident.vue')
  },
  {
    path: '/detail5',
    name: 'detail5',
    meta:{
      title: "在职职工意外伤害互助保障"
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/special/detail5.vue')
  },
  {
    path: '/detail6',
    name: 'detail6',
    meta:{
      title: "在职职工子女意外伤害互助保障"
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/special/detail6.vue')
  },
  {
    path: '/detail7',
    name: 'detail7',
    meta:{
      title: "在职职工短期意外伤害互助保障"
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/special/detail7.vue')
  },
  {
    path: '/detail8',
    name: 'detail8',
    meta:{
      title: "在职职工意外伤害互助保障(D款)"
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/special/detail8.vue')
  },
  {
    path: '/detail9',
    name: 'detail9',
    meta:{
      title: "在职职工轻度疾病互助保障活动"
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/special/detail9.vue')
  },
  {
    path: '/detail10',
    name: 'detail10',
    meta:{
      title: "在职职工重大疾病互助保障"
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/special/detail10.vue')
  },
  {
    path: '/detail11',
    name: 'detail11',
    meta:{
      title: "在职女职工特殊疾病互助保障"
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/special/detail11.vue')
  },
  {
    path: '/welfare',
    name: 'welfare',
    meta:{
      title: "会员权益"
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/special/welfare.vue')
  },
  {
    path: '/vipShop',
    name: 'vipShop',
    meta:{
      title: "工会会员活动"
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/special/vipShop.vue')
  }
]

const router = new VueRouter({
  routes
})
// 全局后置钩子
router.afterEach(to => {
	// 设置title
	document.title = to.meta.title;
})

export default router
